import React from "react"
import { Box } from "@chakra-ui/react"
import {
  BadgeElement, BadgeElementType, BadgeQRData,
} from "sharedTypes/badge"
import QRCodePlaceholder from "./QRCodePlaceholder"

type Props = {
  element: BadgeElement
}

const BadgeQRCode = ({ element }: Props) => {
  if (element.type !== BadgeElementType.QR_CODE) return null

  const qrData = element.data as BadgeQRData

  return (
    <Box w="full" h="full" position="relative">
      <QRCodePlaceholder format={qrData.format} />
    </Box>
  )
}

export default BadgeQRCode
